<template>
  <div class="referral mx-1">
    <SentTable />
  </div>
</template>
<script>
import SentTable from "@/components/sms/SentTable";
export default {
  components: { SentTable },
  data() {
    return {};
  },
};
</script>
